import Vue from 'vue'
import Vuex from 'vuex'
import {user} from './modules/user'
import {bot} from './modules/bot'
import {core} from './modules/core'
import blocksBuild from './modules/blocks-build'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    bot,
    core,
    blocksBuild
  },
})

export default store
